import { PaginationInput } from '../common/paginationInput';
import { BrandFilter } from './brandFilter';

export class BrandInput {
  paginationInput: PaginationInput = new PaginationInput(null, null);
  filter: BrandFilter;
}
